import ClpTable from "components/ClpTable"
import { useMemo } from "react"

const ImportResult = ({ result }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "legacyExamImportDto.username",
        header: "Användarnamn"
      },
      {
        accessorKey: "legacyExamImportDto.examName",
        header: "Utbildning"
      },
      {
        accessorKey: "legacyExamImportDto.score",
        header: "Poäng"
      },
      {
        accessorKey: "legacyExamImportDto.urlToPdf",
        header: "Url"
      },
      {
        accessorFn: (cell) => {
          return cell.legacyExamImportDto.pass ? "Ja" : "Nej"
        },
        header: "Godkänd"
      },
      {
        accessorKey: "legacyExamImportDto.examDateSwedishLocal",
        header: "Datum"
      },
      {
        accessorFn: (cell) => {
          return cell.successImport ? "Importerad" : "Trasig"
        },
        header: "Importstatus"
      },
      {
        accessorFn: (cell) => {
          return cell.isValid ? "OK" : "Inte OK"
        },
        header: "Valideringstatus"
      },
      {
        accessorFn: (cell) => {
          return cell.messages.map((item) => {
            return <span>{item}; </span>
          })
        },
        header: "Meddelanden"
      }
    ],
    []
  )

  return (
    <ClpTable rows={result?.status === 2 && result?.data} loadingState={result?.status} columns={columns} />
  )
}

export default ImportResult
